import { AppShell } from './AppShell';

/**
 * Честный исход, когда человеку не открыт ни один рабочий раздел.
 *
 * Вынесен в одну точку: корневой маршрут и отказ по праву обязаны показывать
 * один и тот же экран. Каркас здесь обязателен: именно он держит аварийный
 * возврат владельца из просмотра под чужой ролью.
 */
export function NoAccessibleSections() {
  return (
    <AppShell>
      <div className="ops-skin flex min-h-[60vh] items-center justify-center p-6">
        <div className="max-w-md rounded-ops-card border border-ops-border bg-ops-surface p-8 text-center shadow-ops-card">
          <div className="text-ops-h2 font-bold text-ops-text">Вам пока не открыт ни один раздел</div>
          <p className="mt-3 text-sm leading-relaxed text-ops-text-secondary">
            Все разделы либо закрыты правами, либо спрятаны настройкой доступа. Попросите
            владельца открыть тот раздел, который нужен вам для работы.
          </p>
        </div>
      </div>
    </AppShell>
  );
}
